import { getColor } from '../../theme-tools';
import { asMultiStyleConfig } from '../../utils/theme';
import { getDefaults } from './input';
var parts = ['root', 'modalContainer', 'modalBody', 'modalFooter'];
var baseStyle = props => ({
  root: (() => {
    var {
      theme
    } = props;
    var {
      focusBoxShadowColor
    } = getDefaults(props);
    return {
      '& .tqc-date-picker__day': {
        '&--mobile': {
          width: '44px !important',
          height: '44px !important',
          marginBottom: '1.25rem',
          fontWeight: '700 !important',
          fontSize: '1.25rem !important',
          lineHeight: '1.25rem !important'
        }
      },
      '& .tqc-date-picker__calendar-icon': {
        color: 'blue.600'
      },
      '& .tqc-date-picker__popper': {
        zIndex: 'popover'
      },
      '& .tqc-date-picker__calendar': {
        boxShadow: '0px 0px 40px 0px rgba(0,0,0,0.12), 0px 0px 8px 0px rgba(0,0,0,0.1)',
        border: 'none',
        borderRadius: 'lg',
        fontFamily: 'body',
        width: '17.5rem',
        '&--mobile': {
          width: '100%',
          borderRadius: '0',
          boxShadow: 'none'
        },
        '&:not(.tqc-date-picker__calendar--mobile)': {
          '.tqc-date-picker__header': {
            '.tqc-select__control': {
              maxW: '5.875rem'
            },
            '.tqc-select__input': {
              maxW: '2.5rem'
            }
          }
        }
      },
      '& .tqc-date-picker__header': {
        borderBottom: "1px solid ".concat(getColor(theme, 'grey.300')),
        alignItems: 'center',
        py: '.625rem',
        px: 0,
        '.tqc-select__indicators': {
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)'
        }
      },
      '& .react-datepicker__header': {
        bg: 'white',
        borderBottom: 'none',
        pt: 0
      },
      '& .react-datepicker__month-container': {
        width: '100%'
      },
      '& .react-datepicker__month': {
        m: 2
      },
      '& .react-datepicker__week': {
        display: 'flex',
        justifyContent: 'space-around'
      },
      '& .react-datepicker__day': {
        textStyle: 'lead-lg',
        height: 8,
        width: 8,
        borderRadius: 'full',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        _hover: {
          bg: 'blue.1140'
        },
        _focus: {
          outline: 'none',
          boxShadow: "0 0 0.1875rem 0.125rem ".concat(getColor(theme, 'blue.300'))
        },
        _pressed: {
          bg: 'blue.1150'
        },
        '&--selected': {
          bg: 'blue.600',
          _focus: {
            outline: 'none',
            boxShadow: "0 0 0.1875rem 0.125rem ".concat(getColor(theme, 'blue.300'))
          },
          _hover: {
            bg: 'blue.600'
          }
        },
        '&--disabled': {
          color: 'grey.400',
          cursor: 'not-allowed',
          _hover: {
            bg: 'transparent'
          }
        },
        '&--keyboard-selected': {
          bg: 'transparent',
          color: 'black',
          _focus: {
            boxShadow: "0 0 0.1875rem 0.125rem ".concat(getColor(theme, focusBoxShadowColor)),
            outline: 'none',
            color: 'black'
          }
        },
        '&--today': {
          borderColor: 'blue.600',
          borderWidth: '1px',
          borderRadius: 'full',
          borderStyle: 'solid'
        }
      },
      '& .react-datepicker__day-names': {
        display: 'flex',
        justifyContent: 'space-around',
        mx: 2,
        mt: 2,
        mb: 0
      },
      '& .react-datepicker__day-name': {
        textTransform: 'uppercase',
        color: 'grey.800',
        fontSize: 'xs'
      },
      '& .react-datepicker__day--outside-month': {
        fontWeight: 'normal',
        color: 'grey.800',
        '&.react-datepicker__day--disabled': {
          color: 'grey.400'
        },
        '&.react-datepicker__day--selected': {
          color: 'white'
        }
      },
      '& .tqc-date-picker__nav-button': {
        fontSize: 'md',
        borderRadius: 'full',
        color: 'blue.600',
        mx: '.375rem',
        _disabled: {
          cursor: 'not-allowed',
          color: 'grey.500'
        },
        _pressed: {
          bg: 'blue.1150'
        }
      },
      '& .react-datepicker__triangle': {
        display: 'none'
      }
    };
  })(),
  modalContainer: {
    background: 'white',
    margin: '0',
    maxHeight: '100vh',
    height: '100vh',
    borderRadius: '0',
    width: '100vw',
    maxWidth: '100vw'
  },
  modalBody: {
    padding: {
      base: 0,
      md: 0
    }
  },
  modalFooter: {
    bg: 'grey.250',
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    '& > button:first-of-type': {
      mb: 8
    }
  }
});
export default asMultiStyleConfig({
  parts,
  baseStyle
});